import { Box, Container, Divider, Paper, Typography } from "@mui/material";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-cards";
import { MdAccessible, MdPets } from "react-icons/md";
import { HiWifi } from "react-icons/hi";
import { FaChild, FaParking } from "react-icons/fa";

interface IItem {
  title: string;
  content: JSX.Element;
}

const items: IItem[] = [
  {
    title: "Tradiční české jídlo",
    content: (
      <>
        U nás v restauraci si zajisté vyberete. Steaky, burgery, saláty i
        polední hotovky.
        <br />
        <br />
        Myslíme i na celiaky. V denní nabídce máme i bezlepkovou svíčkovou či
        pečenou kachnu s houskovými i bramborovými knedlíky i sladké pokrmy.
      </>
    ),
  },
  {
    title: "Penzion na ubytování",
    content: (
      <>
        Nabízíme 7 dvoulůžkových pokojů s vlastním sociálním zařízením pro firmy
        i turisty, kteří míří do Kutné Hory, na Kačinu nebo do Žlebů
      </>
    ),
  },
  {
    title: "Rodinné oslavy, svatby a firemní akce",
    content: (
      <>
        Zajistíme pro Vás catering na míru, dle Vašich požadavků.
        <br />
        <br />
        Pro svatby navaříme, vyzdobíme a postaráme se i o doprovodný program.
      </>
    ),
  },
];

const About: React.FC = () => {
  return (
    <Container sx={(theme) => ({ marginY: theme.spacing(4) })} maxWidth="xl">
      <Typography
        id="sluzby"
        sx={{ textAlign: "center", fontWeight: "bold", marginBottom: 4 }}
        component="h2"
        variant="h4"
      >
        Naše služby
      </Typography>
      <Box
        sx={(theme) => ({
          display: "flex",
          [theme.breakpoints.down("md")]: { display: "none" },
        })}
      >
        {items.map((item, index) => (
          <Paper
            key={index}
            sx={(theme) => ({
              width: "100%",
              padding: theme.spacing(4),
              margin: theme.spacing(1),
            })}
          >
            <Typography component="h4" sx={{ fontWeight: 600, fontSize: 18 }}>
              {item.title}
            </Typography>
            <Divider sx={{ marginY: 2, width: "25%" }} />
            <Typography>{item.content}</Typography>
          </Paper>
        ))}
      </Box>
      <Box
        sx={(theme) => ({
          overflow: "hidden",

          [theme.breakpoints.up("md")]: { display: "none" },
        })}
      >
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          pagination={{ clickable: true }}
          loop
          autoplay={{ delay: 5000 }}
        >
          {items.map((item, index) => (
            <SwiperSlide
              key={index}
              style={{ height: "100% !important", paddingBottom: 40 }}
            >
              <Paper
                sx={(theme) => ({
                  padding: theme.spacing(2),
                  margin: theme.spacing(2),
                  height: "100%",
                  minHeight: "100%",
                })}
              >
                <Typography
                  component="h4"
                  sx={{ fontWeight: 600, fontSize: 18 }}
                >
                  {item.title}
                </Typography>
                <Divider sx={{ marginY: 2, width: "25%" }} />
                <Typography>{item.content}</Typography>
              </Paper>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      <Box
        sx={{
          display: "flex",
          marginTop: 4,
          flexWrap: "wrap",
          color: "#474747",
          justifyContent: "center",
          alignItems: "center",
          gap: 5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <MdAccessible size={45} />
          <Typography>Bezbariérový přístup</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <HiWifi size={45} />
          <Typography>Bezplatná WiFi</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <FaChild size={45} />
          <Typography>Dětský koutek</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <FaParking size={45} />
          <Typography>Parkoviště</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <MdPets size={45} />
          <Typography>Domácí mazlíčci vítáni</Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default About;
